import { Component, signal, WritableSignal } from '@angular/core';
import { DashboardElement } from '../dashboard-element/dashboard-element';

import { TranslateModule } from '@ngx-translate/core';
export type TrendWordItem = {
  word: string,
  searchCount: number,
  position: 'up' | 'down' | 'equal';
}

/**
 * Ce composant pemet d'**afficher les mots en tendances** les plus recherché par les utilisateur **par semaine** dans une liste de 3 elements.
 * il est entierement automome.
 * *!! pour le moment il manque encore un apel d'api coté back pour reccuperer les datas.!!*
 */
@Component({
  selector: 'app-weekly-trends',
  imports: [TranslateModule, DashboardElement],
  templateUrl: './weekly-trends.html',
  styleUrl: './weekly-trends.scss',
})
export class WeeklyTrends {

  trends: WritableSignal<TrendWordItem[]> = signal([
    {
      word: "Mont-Ventoux",
      position: "up",
      searchCount: 435536
    },
    {
      word: "Campagne",
      position: "equal",
      searchCount: 23465
    },
    {
      word: "Tour de France",
      position: "down",
      searchCount: 76245
    },
  ])

}
